import React, { useMemo } from "react"
import { Box, Container, Heading } from "@chakra-ui/react"

import useSanitySearch from "@hooks/useSanitySearch"
import TileCarousel from "@components/TileCarousel/TileCarousel"
import PageItem from "./PageItem"
import useSearchSettings from "@hooks/useSearchSettings"

const PageResults = ({ titleResults, titleNoResults, defaultPages, theme, carouselSettings }: GatsbyTypes.SanitySectionPageResults) => {
  const {
    sanityResults: { pages },
  } = useSanitySearch()
  const { suggestions } = useSearchSettings()

  const parsedDefaultPages = useMemo(
    () =>
      defaultPages?.map(page => ({
        title: page?.title,
        link: { url: `/${page?.handle?.current}` },
        description: page?.metadata?.description,
      })),
    [defaultPages]
  )

  const items = useMemo(() => {
    if (parsedDefaultPages?.length) return parsedDefaultPages
    if (pages.length) return pages
    if (suggestions?.pages?.length) return suggestions.pages
  }, [pages, parsedDefaultPages, suggestions.pages])

  const title = useMemo(() => (pages.length ? titleResults : titleNoResults), [pages, titleNoResults, titleResults])

  return items?.length ? (
    <Box bg={theme === "Dark" ? "brand.beige.dark" : "white"}>
      <Container pt={3} pb={6} textAlign="center">
        <Heading as="h2" size="h2" mb={3}>
          {title}
        </Heading>
        {items.length > 0 && (
          <TileCarousel carouselSettings={carouselSettings}>
            {items.map(page => (
              <Box mb={3.5} key={page.key}>
                <PageItem {...page} />
              </Box>
            ))}
          </TileCarousel>
        )}
      </Container>
    </Box>
  ) : null
}

export default PageResults
